export default __webpack_public_path__ + "static/media/2251.f056504d.png";